import { Box, Card, Typography, useTheme } from '@mui/material';
import React from 'react';
import { normalizeDateOnlyToTimezone } from '../../../helpers/datetime';
import { Package } from 'react-feather';
import PersonIcon from '@mui/icons-material/Person';
import { truncateWithLength } from '../helper';

export default function OrderItem({ data, onClick }) {
  const theme = useTheme();
  return (
    <Card
      variant="outlined"
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '8px',
        backgroundColor: theme.palette.background.light,
        width: '100%',
        cursor: 'pointer',
      }}
      onClick={onClick}
    >
      <Package />
      <Box style={{ flexGrow: 1, marginLeft: '6px' }}>
        <Box display="flex" alignItems="center">
          <Typography variant="subtitle2">#{data?.order_ids}</Typography>
          {data?.name && (
            <Box display="flex" style={{ marginLeft: '6px' }} alignItems="center">
              <PersonIcon color="secondary" style={{ fontSize: '16px' }} />
              <Typography variant="body2" noWrap color="textSecondary">
                {truncateWithLength(data?.name, 30)}
              </Typography>
            </Box>
          )}
        </Box>
        <Box display="flex" alignItems="center">
          <Typography variant="body1" style={{ fontSize: '12px' }}>
            {truncateWithLength(data?.brand_name, 30)}
          </Typography>
          <Box height={'4px'} width={'4px'} border={'2px solid'} borderRadius={'50%'} mx={2} />
          <Typography variant="body1" style={{ fontSize: '12px' }}>
            Placed on {data?.marketplace_create_time ? normalizeDateOnlyToTimezone(data?.marketplace_create_time) : '-'}
          </Typography>
        </Box>
      </Box>
    </Card>
  );
}
